import React, { useEffect, useState } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import { getStorefront } from '../api/storeApi';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState('#FC8C4D'); // Default color

  useEffect(() => {
    const fetchStorefront = async () => {
      try {
        const storefront = await getStorefront();
        setPrimaryColor(storefront.primary_color);
      } catch (error) {
        console.error('Error fetching storefront theme:', error);
      }
    };

    fetchStorefront();
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: primaryColor,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
    },
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
